"use client";
import SectionPage from "@/components/common/section-page";
import { useNavigate } from "react-router-dom";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

            <EspaceProTitleCard title={"Le Rendez-vous des Pros"}
                                middleBreadcrumbs={[{title: "L’Office et Vous", link: "/espace-pro/office-et-vous"}]}
                                description={"Découvrez les missions et la vision de cette structure dotée de ressources importantes au cœur de l’écosystème touristique ivoirien."} />

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">

              <h3 className={"text-2xl font-bold font-exo-bold text-bleu-ciel mb-4"}>
                  Les rencontres
              </h3>

             <p className={"text-normal mb-8"}>
                 Des services pour vous … avec 1 objectif : développer votre activité !
                 <br/><br/>
                 De nombreux rendez-vous, des ateliers, des échanges …
                 <br/><br/>
                 De la pratique et du sérieux, mais dans la convivialité.
             </p>
          </SectionPage>

        </div>
  );
}
